// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qwa9a","newExpiryDate":"styles_newExpiryDate__3wi4x","footer":"styles_footer__30pBL"};